import router from "@/router";
import PersistentData from "@/classes/PersistentData";

const pd = new PersistentData('help');

// Non-reactive inputs would be stale in a Vuex getter
// run from checkTourState instead.
function computeShouldShowTour(rootGetters) {
	if (pd.getData('tour/viewed')) {
		return false;
	}

	if (router?.currentRoute?.query?.skipWalkthrough !== undefined) {
		return false;
	}

	if (window.innerWidth < 1023) {
		return false;
	}

	if (rootGetters["config/features"]?.tour?.disabled) {
		return false;
	}

	if (rootGetters["deepLinking/isDeepLink"]) {
		return false;
	}

	return true;
}

const state = {
	tourVisible: false,
	showToast: true,
	showHelp: false
};

const getters = {};

const actions = {
	dismissTour({commit, state}, remember) {
		if (state.tourVisible && remember) {
			pd.setData('tour/viewed', true);
			/*try {
				window.localStorage.setItem("wed", "true");
			} catch (e) {
				console.log(e);
			}*/
		}
		commit("SET_TOUR_VISIBILITY", false);
	},

	viewTour({commit}) {
		commit("SET_TOUR_VISIBILITY", true);
	},

	checkTourState({commit, getters}) {
		/*const viewed = () => {
		  try {
			return window.localStorage.getItem("wed");
		  } catch (e) {
			return true;
		  }
		};
		if (
		  viewed() == "true" ||
		  getUrlParameter("skipWalkthrough") ||
		  // window.innerWidth < 1200
		  window.innerWidth < 1023
		) {
		  commit("SET_TOUR_VISIBILITY", false);
		} else {
		  commit("SET_TOUR_VISIBILITY", true);
		}*/


		commit("SET_TOUR_VISIBILITY", computeShouldShowTour(getters));

	},

	toggleHelp({commit, state}) {
		commit("SET_HELP", !state.showHelp);
	}
};

const mutations = {
	SET_HELP(state, val) {
		state.showHelp = val;
	},
	SET_TOUR_VISIBILITY(state, val) {
		state.tourVisible = val;
		if (val) {
			state.showHelp = false;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
